export const CATEGORY_KEY_PREFIX = "category:";

export const ALL_PRODUCTS_KEY = "All Products";

export const NEW_ARRIVALS_KEY = "New Arrivals";

export const STALE_TIME = 1000 * 60 * 5;

export const BRAND_PAGE_REDESIGN_PAGE_SIZE = 20;
